import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'

export default {
  async getBrands (context) {
    try {
      const brandsResponse = await api.customer.getServiceProviders(true, true)
      context.commit('setBrands', brandsResponse)
      return brandsResponse
    } catch (e) {
      Logger.error('Error getting brands')
      Logger.debug(e)
      throw e
    }
  }
}
